import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';

//API
import unidadeMonetaria_api from '../../../../api/unidadeMonetaria_api';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroUnidadeMonetaria from './components/CadastroUnidadeMonetaria';

//Context
import { useAuth } from '../../../../context/auth';

//Helpers
import { showMessage } from '../../../../helpers/message';

function UnidadeMonetaria({ permissoes }) {
    const { setLoading } = useAuth();

    // state para lista as unidades monetaria
    const [listaUnidadeMonetaria, setListaUnidadeMonetaria] = useState([]);

    //state para criar nova unidade monetaria
    const [unidadeMonetariaNovo, setUnidadeMonetariaNovo] = useState(false);

    //state para Edita o unidade monetaria
    const [unidadeMonetaria_id, setUnidadeMonetaria_id] = useState(null);

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    const editar = (rowData) => {
        setUnidadeMonetaria_id(rowData.id)
    }

    const visualizar = (rowData) => {
        setUnidadeMonetaria_id(rowData.id)
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editar)]
            : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        {
            value: "Início vigência", objectValue: "inicioVigencia", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listaUnidadeMonetaria[dataIndex]?.inicioVigencia).format("DD/MM/YYYY")}</>
                }
            }
        },
        {
            value: "Fim vigência", objectValue: "fimVigencia", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{moment(listaUnidadeMonetaria[dataIndex]?.fimVigencia).format("DD/MM/YYYY")}</>
                }
            }
        },
        { value: "Valor", objectValue: "valor", align: "left" }
    ];

    const loadUnidadesMonetaria = () => {
        setLoading(true)
        unidadeMonetaria_api.getList()
            .then(response => {
                response.data.map(value => {
                    value.valor = "R$ " + value.valor.toFixed(2).replace(".", ",");
                    return value;
                });
                setListaUnidadeMonetaria(response.data);
            })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadUnidadesMonetaria();
    }, []);

    const handleVoltar = () => {
        setUnidadeMonetaria_id(null);
        setUnidadeMonetariaNovo(false);
        loadUnidadesMonetaria();
    }

    if (unidadeMonetariaNovo || unidadeMonetaria_id) {
        return <CadastroUnidadeMonetaria
            editavel={editavel}
            id={unidadeMonetaria_id}
            handleVoltar={handleVoltar}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Unidade Monetária</h4>
            {editavel &&
                <Button color='success' onClick={() => { setUnidadeMonetariaNovo(true) }}>+ Cadastrar</Button>
            }
        </div>
        <TabelaListagem
            actions={actions}
            title={"Lista de Unidades Monetárias"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listaUnidadeMonetaria}
        />
    </>;
}

export default UnidadeMonetaria;